// extracted by mini-css-extract-plugin
export default {"CurrencyInput":"CurrencyInput_CurrencyInput__WCdJI"};